var _rect, _title, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudhawkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 85,
    preserveAspectRatio: "xMidYMid meet",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,85) scale(0.10000000149011612,-0.10000000149011612) ",
    fill: "#349ed4",
    stroke: "none",
    id: "svg_1",
    className: "",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606 804 c-48 -58 -97 -77 -209 -82 -114 -5 -110 -1 -111 -136 l-1 -78 -40 5 c-22 3 -49 8 -59 13 -15 6 -17 4 -11 -6 10 -16 -4 -8 -53 28 -27 21 -31 22 -25 6 6 -16 3 -15 -25 4 -17 13 -40 34 -52 49 -24 31 -26 16 -4 -56 10 -34 29 -66 55 -92 21 -21 33 -39 27 -40 -20 -1 64 -38 87 -39 15 0 17 -2 7 -9 -17 -10 16 -21 65 -21 55 0 97 -51 53 -65 -29 -9 -24 -25 8 -25 23 0 35 -11 71 -66 24 -36 66 -83 94 -105 58 -46 137 -89 164 -89 34 0 145 74 198 132 100 108 143 226 152 419 8 167 6 169 -96 169 -103 0 -163 21 -217 77 -23 23 -44 43 -46 42 -1 0 -16 -16 -32 -35z m78 -58 c61 -46 107 -61 199 -61 l77 0 0 -111 c0 -228 -77 -395 -226 -490 -76 -49 -94 -51 -155 -17 -95 51 -218 198 -190 226 17 17 13 27 -9 27 -11 0 -20 5 -20 11 0 7 9 9 22 6 28 -8 71 16 99 54 18 26 19 33 8 40 -8 5 -20 9 -28 9 -7 0 -42 14 -78 32 l-64 31 3 91 3 91 57 -3 c33 -2 80 3 114 13 57 16 134 60 134 76 0 14 7 11 54 -25z",
    id: "svg_2",
    fill: "#349ed4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895 613 c-12 -14 -33 -27 -47 -28 -15 -2 -31 -6 -36 -9 -5 -3 -49 -8 -98 -12 -93 -6 -136 -21 -154 -55 -16 -29 -7 -44 39 -74 39 -24 44 -24 112 -15 39 6 80 15 91 21 32 17 78 61 73 70 -3 4 0 11 6 15 6 3 20 25 30 48 30 67 22 87 -16 39z",
    id: "svg_3",
    fill: "#349ed4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 473 c-37 -7 -26 -21 22 -29 42 -6 64 -24 30 -24 -13 0 -14 -4 -4 -21 10 -19 8 -20 -10 -14 -25 8 -27 2 -5 -19 12 -12 12 -16 2 -16 -9 -1 -8 -5 4 -14 9 -7 19 -28 21 -47 3 -19 8 -43 12 -53 6 -13 3 -23 -10 -32 -10 -8 -19 -24 -21 -37 -2 -21 1 -23 24 -19 15 3 35 13 45 23 20 21 14 44 -9 35 -8 -3 -14 -1 -14 4 0 16 32 11 45 -7 7 -9 17 -13 23 -9 13 7 -30 104 -52 118 -19 13 3 9 41 -7 19 -8 48 -15 63 -15 27 0 28 1 17 31 -12 30 -55 70 -129 119 -21 14 -38 28 -38 33 0 7 -19 7 -57 0z",
    id: "svg_4",
    fill: "#349ed4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 349 c-19 -16 -25 -31 -25 -60 0 -24 5 -39 12 -39 7 0 10 -7 7 -15 -4 -9 0 -15 10 -15 9 0 16 -4 16 -9 0 -15 30 -21 49 -9 17 10 17 14 4 46 -8 19 -13 41 -11 50 2 10 -6 25 -17 34 -12 11 -15 17 -7 18 7 0 10 5 7 10 -9 14 -17 12 -45 -11z",
    id: "svg_5",
    fill: "#349ed4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684 186 c-12 -10 -23 -11 -31 -5 -7 7 -14 6 -19 -2 -4 -8 4 -22 22 -37 25 -22 29 -23 32 -9 2 10 8 15 13 12 5 -4 9 0 9 9 0 8 5 16 11 18 7 2 6 8 -3 16 -12 9 -19 9 -34 -2z",
    id: "svg_6",
    fill: "#349ed4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudhawkIcon);
export default __webpack_public_path__ + "static/media/cloudhawk-icon.1933c5d8a2568d9f96c30a083a5e1e86.svg";
export { ForwardRef as ReactComponent };